import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { logout } from './redux/slices/user'
import { useAuth0 } from '@auth0/auth0-react'
import { useHistory } from 'react-router-dom'

const NotAuthorized: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { logout: auth0Logout } = useAuth0()

  const [secondsLeft, setSecondsLeft] = useState<number>(3)
  const [autoRedirect, setAutoRedirect] = useState<boolean>(true)

  useEffect(() => {
    if (!autoRedirect) return
    if (secondsLeft <= 0) {
      history.push('/web/login')
      return
    }
    const id = setTimeout(() => setSecondsLeft(s => s - 1), 1000)
    return () => clearTimeout(id)
  }, [secondsLeft, autoRedirect, history])

  const handleLogoutAndSwitch = async (): Promise<void> => {
    dispatch(logout())
    await auth0Logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
  }

  const goToClientNow = (): void => {
    history.push('/web/login')
  }

  return (
    <div className="container" style={{ maxWidth: 640, marginTop: '4rem', textAlign: 'center' }}>
      <h2>You&apos;re signed in, but this account only has access to the client web app</h2>
      <p style={{ marginTop: '1rem', color: '#666' }}>
        You can sign out to switch to an account that has access to the this application, or continue to the client web app.
      </p>

      <div style={{ marginTop: '2rem' }}>
        <button
          className="btn btn-lg btn-primary"
          onClick={handleLogoutAndSwitch}
          style={{ marginRight: '0.75rem' }}
        >
          Sign out and switch account
        </button>
        <button
          className="btn btn-lg btn-secondary"
          onClick={goToClientNow}
        >
          Go to client app
        </button>
      </div>

      <div style={{ marginTop: '1.5rem', color: '#666' }}>
        {autoRedirect ? (
          <span>
            Redirecting to client app in {secondsLeft}s…{' '}
            <a href="#" onClick={(e) => { e.preventDefault(); setAutoRedirect(false) }}>
              Cancel
            </a>
          </span>
        ) : (
          <span>Auto-redirect canceled.</span>
        )}
      </div>
    </div>
  )
}

export default NotAuthorized


